import _inherits from "/opt/bread/checkout/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/inherits.js";
import _setPrototypeOf from "/opt/bread/checkout/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/setPrototypeOf.js";

function _wrapRegExp() { _wrapRegExp = function _wrapRegExp(re, groups) { return new BabelRegExp(re, void 0, groups); }; var _super = RegExp.prototype, _groups = new WeakMap(); function BabelRegExp(re, flags, groups) { var _this = new RegExp(re, flags); return _groups.set(_this, groups || _groups.get(re)), _setPrototypeOf(_this, BabelRegExp.prototype); } function buildGroups(result, re) { var g = _groups.get(re); return Object.keys(g).reduce(function (groups, name) { return groups[name] = result[g[name]], groups; }, Object.create(null)); } return _inherits(BabelRegExp, RegExp), BabelRegExp.prototype.exec = function (str) { var result = _super.exec.call(this, str); return result && (result.groups = buildGroups(result, this)), result; }, BabelRegExp.prototype[Symbol.replace] = function (str, substitution) { if ("string" == typeof substitution) { var groups = _groups.get(this); return _super[Symbol.replace].call(this, str, substitution.replace(/\$<([^>]+)>/g, function (_, name) { return "$" + groups[name]; })); } if ("function" == typeof substitution) { var _this = this; return _super[Symbol.replace].call(this, str, function () { var args = arguments; return "object" != typeof args[args.length - 1] && (args = [].slice.call(args)).push(buildGroups(args, _this)), substitution.apply(this, args); }); } return _super[Symbol.replace].call(this, str, substitution); }, _wrapRegExp.apply(this, arguments); }

// N.B. This file is a duplicate of that at apps/apply/lib/namespace.ts
// So far there is no way to share files in libs that are used by our custom
// server.
var ADS = 'alliance';
var RBC = 'rbc';
var InStore = 'in-store/[uuid]';
var Cart = 'cart/[cartID]';
export var NAMESPACE_MAP = {
  ADS: ADS,
  RBC: RBC,
  InStore: InStore,
  Cart: Cart
};

/**
 * Determine if string is a valid namespace.
 *
 * @param namespace - A namespace string.
 *
 * @returns - Returns boolean to determine if namespace is valid.
 *
 */
export function isNamespaceKey(namespace) {
  if (!namespace) {
    return false;
  }

  return Object.keys(NAMESPACE_MAP).includes(namespace);
}

var namespaceRegex = /*#__PURE__*/_wrapRegExp(/^\/((alliance)|(rbc)|(in\x2Dstore\/\[uuid\])|(cart\/\[cartID\]))/, {
  tenant: 1
});
/**
 * Gets namespace from URL.
 *
 * @param pathname - A pathname.
 *
 * @returns - Returns a namespace or undefined.
 *
 */


export function namespaceFromUrl(pathname) {
  var namespaceResult = namespaceRegex.exec(pathname);
  return Object.values(NAMESPACE_MAP).find(function (t) {
    var _namespaceResult$grou;

    return t === (namespaceResult === null || namespaceResult === void 0 ? void 0 : (_namespaceResult$grou = namespaceResult.groups) === null || _namespaceResult$grou === void 0 ? void 0 : _namespaceResult$grou.tenant);
  });
}